// Images served from /public/img to avoid Rollup node_modules resolution issues
const NetSuiteLogo = "/img/NetSuite_Logo.png";
const FormstackLogo = "/img/Formstack_Logo.svg";
const AccelaLogo = "/img/accela.jpg";
const ShopifyLogo = "/img/shopify.png";
const HubSpotLogo = "/img/hubspot.svg";
const Dynamics365Logo = "/img/dynamics365.svg";
const BigCommerceLogo = "/img/bigcommerce.svg";
const WooCommerceLogo = "/img/woocommerce.svg";
const McpLogo = "/img/mcp-server.svg";
const PowerAutomateLogo = "/img/power-automate.svg";
const MakeLogo = "/img/make.svg";
const ZapierLogo = "/img/zapier.svg";
const SlackLogo = "/img/slack.svg";
const TeamsLogo = "/img/teams.svg";
const OutlookCalendarLogo = "/img/outlook-calendar.svg";
const CalendlyLogo = "/img/calendly.svg";
const SquareLogo = "/img/square.svg";
const KlaviyoLogo = "/img/klaviyo.svg";
const StripeLogo = "/img/stripe.svg";
const GorgiasLogo = "/img/gorgias.svg";
const GoogleTagManagerLogo = "/img/google-tag-manager.svg";
const MagentoLogo = "/img/magento.svg";
import { IconPlus } from "@velaro/velaro-component-lib/";

export const applications = [
  {
    id: "new",
    name: "Request New App",
    category: "all",
    icon: IconPlus,
    subTitle:
      "Submit your application integration suggestion by completing our request form"
  },
  {
    id: "netsuite",
    name: "Netsuite CRM",
    category: "all",
    icon: NetSuiteLogo,
    subTitle:
      "Connect directly to manage and streamline your customer communications and data."
  },
  {
    id: "formstack",
    name: "Formstack",
    category: "all",
    icon: FormstackLogo,
    subTitle:
      "Collect, manage, and automate form submissions to enhance workflows and improve data accuracy."
  },
  {
    id: "accela-civic",
    name: "Accela Civic",
    category: "all",
    icon: AccelaLogo,
    subTitle:
      ""
  },
  {
    id: "shopify",
    name: "Shopify",
    category: "all",
    icon: ShopifyLogo,
    subTitle:
      "Integrate Shopify to sync e-commerce activities with customer profiles directly."
  },
  {
    id: "hubspot",
    name: "HubSpot CRM",
    category: "all",
    icon: HubSpotLogo,
    subTitle:
      "Connect HubSpot to look up contacts, push transcripts, and sync chat data to your CRM."
  },
  {
    id: "dynamics",
    name: "Microsoft Dynamics 365",
    category: "all",
    icon: Dynamics365Logo,
    subTitle:
      "Connect Dynamics 365 to look up contacts, create leads and cases, and sync chat data to your CRM."
  },
  {
    id: "bigcommerce",
    name: "BigCommerce",
    category: "all",
    icon: BigCommerceLogo,
    subTitle:
      "Integrate BigCommerce to look up customers, orders, and products during live support chats."
  },
  {
    id: "woocommerce",
    name: "WooCommerce",
    category: "all",
    icon: WooCommerceLogo,
    subTitle:
      "Connect WooCommerce to search products, look up orders, and retrieve customer history during live chats. Supports any WordPress store."
  },
  {
    id: "magento",
    name: "Magento / Adobe Commerce",
    category: "all",
    icon: MagentoLogo,
    subTitle:
      "Connect Magento or Adobe Commerce to look up customers, orders, products, and B2B data during live support chats."
  },
  {
    id: "mcp",
    name: "MCP Servers",
    category: "all",
    icon: McpLogo,
    subTitle:
      "Connect AI workflow nodes to external tools via the Model Context Protocol, with full conversation context awareness."
  },
  {
    id: "power-automate",
    name: "Power Automate",
    category: "automation",
    icon: PowerAutomateLogo,
    subTitle:
      "Trigger Microsoft Power Automate flows from chat conversations and workflow nodes. Bidirectional data exchange."
  },
  {
    id: "make",
    name: "Make (Integromat)",
    category: "automation",
    icon: MakeLogo,
    subTitle:
      "Connect Velaro to 1,000+ apps via Make.com. Trigger scenarios from workflows, send conversation data, and return variables."
  },
  {
    id: "zapier",
    name: "Zapier",
    category: "automation",
    icon: ZapierLogo,
    subTitle:
      "Trigger Zapier Zaps when conversations start, end, or hit milestones. Automate CRM updates, tickets, and notifications."
  },
  {
    id: "slack-notifications",
    name: "Slack Notifications",
    category: "notifications",
    icon: SlackLogo,
    subTitle:
      "Send real-time alerts to Slack channels when conversations resolve, are missed, or breach SLA. Configure per-channel webhooks with custom trigger rules."
  },
  {
    id: "teams-notifications",
    name: "Teams Notifications",
    category: "notifications",
    icon: TeamsLogo,
    subTitle:
      "Send Adaptive Card alerts to Microsoft Teams channels when conversations resolve, arrive, or breach SLA. No Microsoft 365 account required."
  },
  {
    id: "outlook-calendar",
    name: "Outlook Calendar",
    category: "scheduling",
    icon: OutlookCalendarLogo,
    subTitle:
      "Book meetings directly on an Outlook calendar during chat. Send calendar invites, collect preferred times, and confirm bookings — all from the bot."
  },
  {
    id: "calendly",
    name: "Calendly",
    category: "scheduling",
    icon: CalendlyLogo,
    subTitle:
      "Send personalized Calendly booking links to visitors. Let them self-schedule demos, support calls, and appointments without leaving the chat."
  },
  {
    id: "square-appointments",
    name: "Square Appointments",
    category: "scheduling",
    icon: SquareLogo,
    subTitle:
      "Let visitors book appointments via SMS, WhatsApp, or website chat — powered by your Square calendar. No forms, no links."
  },
  {
    id: "stripe-payments",
    name: "Stripe Payments",
    category: "automation",
    icon: StripeLogo,
    subTitle:
      "Send payment requests inside any workflow. Customers pay via Apple Pay, Google Pay, or card — without leaving the chat. Powered by Stripe Checkout."
  },
  {
    id: "klaviyo",
    name: "Klaviyo",
    category: "automation",
    icon: KlaviyoLogo,
    subTitle:
      "Trigger Klaviyo email and SMS flows after conversations resolve. Power post-chat follow-ups, CSAT surveys, and abandoned chat recovery — automatically."
  },
  {
    id: "gorgias",
    name: "Migrate from Gorgias",
    category: "all",
    icon: GorgiasLogo,
    subTitle:
      "Switch from Gorgias to Velaro in 15 minutes. Import your macros as bot Q&A, connect Shopify, and launch an AI that handles support automatically — at half the price."
  },
  {
    id: "google-tag-manager",
    name: "Google Tag Manager",
    category: "all",
    icon: GoogleTagManagerLogo,
    subTitle:
      "Deploy Velaro without code via GTM. Push chat events (chat_started, conversation_resolved) to GA4, Google Ads, and Meta Pixel. Pass visitor variables into the bot."
  }
];
